import React from 'react';
import classNames from 'classnames';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import { addListItemClass } from './List.component';

const OrderedList = (props) => {

  const { children, className } = props;

  const classes = classNames(
    className,
    'list'
  );

  return (
    <ol className={classes}>
      { children && addListItemClass(children, 'list__item') }
    </ol>
  );
};

OrderedList.propTypes = {
  children: oneOfType([
    // List Items are modified to add classes so can't set specific type
    node,
    arrayOf(node)
  ]).isRequired,
  /** Additional class names */
  className: string
};

OrderedList.defaultProps = {
  className: null
};

export default OrderedList;
